export default __webpack_public_path__ + "static/agency-issue-4c695fd5fbd8aa4bd3d9d44f237d50e7.png";